import { InfoBanner } from "@whoosh/design-system/src/components/display/InfoBanner/InfoBanner";
import { Box } from "@whoosh/design-system/src/components/primitive";

export const CardEntryErrorBanner = ({ message }: { message?: string }) =>
  message ? (
    <Box accessibilityRole="alert" accessibilityLiveRegion="polite" pb={4}>
      <InfoBanner
        colorTheme="ERROR"
        type="CARD"
        message={message}
        testID="card-entry-error"
      />
    </Box>
  ) : null;
